// 吃瓜精选 —— 站内展示数据（静态示例内容）

export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
  total: number;
}

export interface Collection {
  id: string;
  title: string;
  category: string;
  score: string;
  votes: string;
  heat: number;
  excerpt: string;
  tags: string[];
  image: string;
}

export interface RankItem {
  id: number;
  title: string;
  category: string;
  score: string;
  heat: number;
  trend: number;
  note: string;
}

export interface Review {
  name: string;
  role: string;
  content: string;
  score: number;
}

export interface Faq {
  q: string;
  a: string;
}

export const navLinks = [
  { label: "今日榜单", href: "#hot" },
  { label: "内容分类", href: "#category" },
  { label: "高分合集", href: "#collection" },
  { label: "口碑见证", href: "#review" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export const heroHotWords = [
  "治愈系剧集",
  "街头美食",
  "小众旅行",
  "家居改造",
  "数码好物",
  "生活方式",
];

export const categories: Category[] = [
  { id: "food", name: "美食探店", icon: "ri-restaurant-2-line", desc: "高分口碑店铺与街头烟火气", total: 368 },
  { id: "movie", name: "影视剧集", icon: "ri-movie-2-line", desc: "年度好评剧集与片单甄选", total: 412 },
  { id: "travel", name: "旅行见闻", icon: "ri-map-pin-line", desc: "小众目的地图鉴与避坑攻略", total: 297 },
  { id: "life", name: "生活方式", icon: "ri-heart-3-line", desc: "当代年轻人的真实日常大赏", total: 501 },
  { id: "tech", name: "科技数码", icon: "ri-cpu-line", desc: "真实体验驱动的数码好物榜", total: 334 },
  { id: "home", name: "家居改造", icon: "ri-home-smile-2-line", desc: "低成本高颜值改造灵感合集", total: 186 },
  { id: "skill", name: "干货技能", icon: "ri-lightbulb-flash-line", desc: "上手即用的实用技能指南", total: 459 },
  { id: "taste", name: "情绪树洞", icon: "ri-chat-heart-line", desc: "引起共鸣的真实故事与心事", total: 276 },
];

export const collections: Collection[] = [
  {
    id: "c1",
    title: "街头烟火气：被网友力荐的高分小吃图鉴",
    category: "美食探店",
    score: "9.4",
    votes: "2.3万+",
    heat: 96,
    excerpt: "从巷口老味道到新晋排队王，本合集集合了点评基数大、好评占比高的街头小吃，为你标注每一家的必点与避雷点。",
    tags: ["小吃", "排队王", "本地人推荐"],
    image: "https://readdy.ai/api/search-image?query=Cozy%20night%20street%20food%20scene%20with%20steaming%20snack%20stalls%2C%20warm%20string%20lights%2C%20golden%20lanterns%20and%20bustling%20atmosphere%2C%20rich%20food%20photography%20on%20a%20wooden%20table%20with%20appetizing%20dishes%2C%20editorial%20style%2C%20soft%20warm%20tones%20and%20inviting%20ambient%20lighting%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=560&seq=gua-food-01&orientation=landscape",
  },
  {
    id: "c2",
    title: "年度治愈系高分剧集清单，网友追完都说值",
    category: "影视剧集",
    score: "9.2",
    votes: "3.1万+",
    heat: 91,
    excerpt: "评分与口碑持续在线的治愈剧集一次集齐，剧情温暖不拖沓，适合窝在沙发里慢慢追，附网友推荐的观看顺序。",
    tags: ["治愈", "好剧", "年度片单"],
    image: "https://readdy.ai/api/search-image?query=Cozy%20cinema%20night%20scene%20with%20a%20blanket%20and%20popcorn%20in%20a%20warm%20living%20room%2C%20soft%20amber%20lamp%20light%20and%20a%20glowing%20screen%20in%20the%20background%2C%20relaxed%20and%20heartwarming%20mood%2C%20editorial%20interior%20photography%2C%20warm%20neutral%20tones%2C%20film%20frame%20vibe%2C%20high%20detail%20and%20gentle%20composition&width=800&height=560&seq=gua-movie-01&orientation=landscape",
  },
  {
    id: "c3",
    title: "新手也能上手的宝藏家居改造，低成本大变化",
    category: "家居改造",
    score: "9.1",
    votes: "1.2万+",
    heat: 84,
    excerpt: "不拆不改也能焕然一新的改造思路合集，从收纳到软装都有真实前后对比，网友复刻率极高，照着做不出错。",
    tags: ["软装", "低成本", "改造对比"],
    image: "https://readdy.ai/api/search-image?query=Bright%20minimal%20living%20room%20makeover%20with%20warm%20wood%20furniture%2C%20layered%20neutral%20linens%20and%20green%20plants%2C%20soft%20natural%20window%20light%2C%20clean%20and%20welcoming%20homely%20atmosphere%2C%20editorial%20interior%20design%20photography%2C%20warm%20earth%20tones%2C%20high%20detail%2C%20balanced%20and%20harmonious%20composition&width=800&height=560&seq=gua-home-01&orientation=landscape",
  },
  {
    id: "c4",
    title: "山海之间：被反复种草的小众旅行目的地图鉴",
    category: "旅行见闻",
    score: "9.3",
    votes: "1.8万+",
    heat: 89,
    excerpt: "避开人潮的小众目的地实测合集，含交通、住宿与最佳季节建议，口碑极佳，适合安排一场说走就走的旅行。",
    tags: ["小众", "避坑", "旅行攻略"],
    image: "https://readdy.ai/api/search-image?query=Serene%20misty%20mountain%20lake%20landscape%20at%20sunrise%20with%20reflective%20still%20water%2C%20layered%20blue-green%20peaks%20and%20soft%20morning%20fog%2C%20peaceful%20off-the-beaten-path%20travel%20destination%2C%20editorial%20travel%20photography%2C%20fresh%20calm%20tones%2C%20high%20detail%2C%20wide%20and%20harmonious%20composition&width=800&height=560&seq=gua-travel-01&orientation=landscape",
  },
  {
    id: "c5",
    title: "当代年轻人生活方式大赏，越看越上头",
    category: "生活方式",
    score: "9.0",
    votes: "4.6万+",
    heat: 88,
    excerpt: "城市青年的真实日常图鉴：极简出行、周末充电、独居小确幸……每一篇都被大量网友点赞收藏，共鸣度超高。",
    tags: ["日常", "极简", "高共鸣"],
    image: "https://readdy.ai/api/search-image?query=Modern%20young%20adult%20lifestyle%20flatlay%20with%20coffee%2C%20open%20notebook%2C%20camera%20and%20eucalyptus%20on%20a%20warm%20cream%20desk%2C%20soft%20morning%20sunlight%2C%20minimal%20and%20bright%20everyday%20scene%2C%20editorial%20lifestyle%20photography%2C%20warm%20natural%20tones%2C%20high%20detail%2C%20tidy%20and%20harmonious%20composition&width=800&height=560&seq=gua-life-01&orientation=landscape",
  },
  {
    id: "c6",
    title: "高分数码好物真实体验榜，买前必看口碑",
    category: "科技数码",
    score: "9.0",
    votes: "1.5万+",
    heat: 80,
    excerpt: "由真实使用反馈沉淀的数码好物清单，标注长短板与适合人群，帮你避开宣传滤镜，只买真正值得的那件。",
    tags: ["数码", "真实体验", "避坑"],
    image: "https://readdy.ai/api/search-image?query=Minimal%20tech%20gadgets%20arranged%20on%20a%20warm%20wooden%20desk%20with%20headphones%2C%20smartwatch%20and%20keyboard%2C%20soft%20natural%20window%20light%20and%20gentle%20shadows%2C%20clean%20premium%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail%2C%20balanced%20and%20harmonious%20composition&width=800&height=560&seq=gua-tech-01&orientation=landscape",
  },
];

export const rankings: RankItem[] = [
  { id: 1, title: "被10万网友刷爆的高分剧集合集", category: "影视剧集", score: "9.6", heat: 99, trend: 3, note: "本周口碑榜首" },
  { id: 2, title: "巷口封神小吃店实测推荐榜", category: "美食探店", score: "9.5", heat: 96, trend: 1, note: "排队王集中营" },
  { id: 3, title: "不看会后悔的小众旅行目的地", category: "旅行见闻", score: "9.4", heat: 93, trend: 2, note: "避开人潮" },
  { id: 4, title: "当代打工人治愈日常图鉴", category: "生活方式", score: "9.3", heat: 90, trend: 0, note: "超高共鸣" },
  { id: 5, title: "低成本高颜值家居改造合集", category: "家居改造", score: "9.2", heat: 86, trend: 1, note: "复刻率超高" },
  { id: 6, title: "买前必看的高分数码好物榜", category: "科技数码", score: "9.1", heat: 82, trend: -1, note: "真实体验" },
  { id: 7, title: "新手十分钟上手的实用技能合集", category: "干货技能", score: "9.0", heat: 78, trend: 2, note: "收藏过万" },
  { id: 8, title: "让网友瞬间破防的真实故事墙", category: "情绪树洞", score: "8.9", heat: 74, trend: 1, note: "引发共鸣" },
  { id: 9, title: "越逛越上头的宝藏生活方式分享", category: "生活方式", score: "8.8", heat: 70, trend: -2, note: "日常灵感" },
  { id: 10, title: "编辑部亲测的宝藏早餐地图", category: "美食探店", score: "8.8", heat: 66, trend: 0, note: "每日更新" },
];

export const reviews: Review[] = [
  { name: "老瓜农·阿哲", role: "追更3年", content: "刷完这份高分合集，周末行程直接给我安排明白了，评分很真实，踩雷率比我自己找低太多了。", score: 5 },
  { name: "奶茶不加冰", role: "新吃瓜人", content: "第一次来就被榜单种草到，跟着网友力荐的剧集合集追，每一部都没让我失望，值回票价。", score: 5 },
  { name: "山川和风", role: "旅行爱好者", content: "小众旅行图鉴太顶了，连交通和最佳季节都标清楚，按攻略走一趟，全程零踩雷。", score: 4 },
  { name: "南巷旧人", role: "家居控", content: "家居改造那篇我照着复刻了阳台一角，低成本真有奇效，现在天天想回家。", score: 5 },
  { name: "今天也要开心", role: "干饭人", content: "街角小吃那几期我基本吃遍了，好评不是吹的，编辑比我自己会找多了哈哈。", score: 5 },
  { name: "豆豆的猫", role: "数码用户", content: "数码榜讲实话，长短板写得明明白白，买之前看一眼能少踩好几个坑，很良心。", score: 4 },
];

export const faqs: Faq[] = [
  { q: "吃瓜精选里的内容是怎么来的？", a: "我们持续收集全网被反复提及、分享与收藏的热门主题，再由编辑结合真实网友反馈与评分，逐期整理成高分合集，确保每篇都值得一看。" },
  { q: "合集的评分是如何产生的？", a: "评分综合了真实网友的点评数量、好评占比、收藏与转发热度，并经过多次人工复核，分数只反映整体口碑，不掺水也不刷分。" },
  { q: "为什么有的合集分数特别高？", a: "分数高的合集通常点评基数大、好评持续且争议小。我们只收录绝大多数用户真心认可的内容，让高分更可信。" },
  { q: "我可以投稿推荐自己喜欢的内容吗？", a: "当然可以。你可以通过页面下方的投稿表单提交你心中的好瓜，审核通过后我们会补充评分与点评并纳入对应合集。" },
  { q: "精选合集多久更新一次？", a: "口碑榜单每天动态更新，高分合集每周甄选一次，确保你打开时看到的都是当下最受认可的内容。" },
  { q: "如何确保评价真实、口碑可信？", a: "我们坚持真实网友优先、拒绝注水刷分，所有点评都会核对来源，同时定期清理异常数据，守住口碑内容的底线。" },
];

export const stats = [
  { num: "3200+", label: "甄选高分合集" },
  { num: "58万+", label: "真实网友点评" },
  { num: "92.6%", label: "平均好评占比" },
  { num: "每周", label: "精选持续更新" },
];